import { jsx as _jsx } from "react/jsx-runtime";
import Checkbox from './Checkbox';
export default function Radio(props) {
    return _jsx(Checkbox, Object.assign({ type: "radio" }, props));
}
